// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchBar_wrapper__TFuvG","icon":"SearchBar_icon__YNSby","input":"SearchBar_input__kqcHy"};